<h2 mat-dialog-title>{{ 'UploadADocument' | translate: {Default: "Upload a document"} }}</h2>

<mat-dialog-content>
    <div>
        <div>
            <button mat-raised-button class="primary-button" appPreventDoubleClick (throttledClick)="fileInput.click()">
                {{ 'ChooseAFile' | translate: {Default: "Choose a file"} }}
            </button>
            <input
                #fileInput
                type="file"
                id="fileInput"
                (change)="selectFile($event)"
                name="fileInput"
            />
        </div>
        <div *ngIf="currentFile">
            <div class="current-file">
                <mat-toolbar class="progress-bar">
                    <mat-progress-bar color="accent" [value]="progress"></mat-progress-bar>
                    <span class="progress">{{ progress }}%</span>
                </mat-toolbar>
                <div class="current-file-details">
                    <div class="current-file-name">{{currentFile.name}}</div>
                    <div class="current-file-size">{{ currentFile.size | filesize }}</div>
                </div>
            </div>
            <!-- <div>
                <mat-form-field appearance="fill">
                    <mat-label>
                        Select A Directory
                    </mat-label>
                
                    <mat-select disableOptionCentering [(ngModel)]="selectedDirectory">
                        <mat-option value=''>
                            None
                        </mat-option>

                        <ng-container *ngFor="let directory of directories$ | async">
                            <mat-option *ngIf="directory.elementType === 'FOLDER'" [value]="directory.id">{{directory.name}}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div> -->
        </div>
    </div>

    <div *ngIf="message" class="message">
        {{ message }}
    </div>
 
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
    <button 
        mat-raised-button 
        class="primary-button submit-button"
        appPreventDoubleClick (throttledClick)="upload()" 
        [disabled]="!currentFile">
        {{ 'Upload' | translate: {Default: "Upload"} }}
    </button>
</mat-dialog-actions>